module.exports = __webpack_public_path__ + "img/food-hero-business-m.5dd6fe8c.jpg";